<div *ngIf="loaded && image" class="heatmap-results-container">
    <div class="header">
        <div class="header-text">Filter by:</div>
        <mat-form-field appearance="outline" class="noBottomPadding" color="accent">
            <mat-label>Option</mat-label>
            <mat-select [formControl]="option">
                <mat-option [value]="-1">All</mat-option>
                <mat-option *ngFor="let optionValue of options" [value]="optionValue.id">
                    <div class="flex-row gap-5 align-items-center">
                        <div *ngIf="optionValue.color" [style.background-color]="optionValue.color"
                             class="color-indicator"></div>
                        {{ optionValue.text }}
                    </div>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <button [mat-dialog-close]="false" class="mat-dialog-close close-icon-button" mat-icon-button
            matTooltip="Close modal"
            tabindex="-1">
        <mat-icon class="accent-text">close</mat-icon>
    </button>
    <div class="content">
        <app-heatmap
            #heatmapComponent='heatmap'
            [autoMaxIntensity]="true"
            [clickData]="clickData"
            [disableVotes]="true"
            [img]="image"
            [maxHeight]="true"
        ></app-heatmap>
    </div>
    <div class="user-votes-list">
        <div [class.adminTable]="isSuperuser || hasCommunityRole(['full_admin'])" class="custom-table">
            <div class="table-header">
                <div class="table-cell header-cell">#</div>
                <div class="table-cell header-cell">Preview</div>
                <div class="table-cell header-cell">Option</div>
                <div class="table-cell header-cell">Comments</div>
                <div *ngIf="isSuperuser || hasCommunityRole(['full_admin'])" class="table-cell header-cell">User</div>
            </div>

            <div class="table-body">
                <div *ngFor="let vote of votes; let i = index" class="table-row">
                    <div class="table-cell">{{ i + 1 }}</div>
                    <div class="table-cell">
                        <app-heatmap
                                [clickData]="getClickData(vote)"
                                [disableVotes]="true"
                                [doubleMaxClickRadius]="true"
                                [img]="image"
                                [maxHeight]="true"
                                [strictColor]="getOption(vote.option)?.color"
                                [strictPoints]="true"
                        ></app-heatmap>
                    </div>
                    <div class="table-cell">{{ getOption(vote.option)?.text }}</div>
                    <div class="table-cell">{{ vote.comment }}</div>
                    <div *ngIf="isSuperuser || hasCommunityRole(['full_admin'])" class="table-cell">

                        {{ vote?.user?.id }}
                        <!--                        class userrow-->
                        <!--                        <ng-container *ngIf="vote.user">-->
                        <!--                            <div mat-card-avatar class="miniInitial clickable mb-0" [matMenuTriggerFor]="menu"-->
                        <!--                                 [appUserAvatar]="vote.user">{{ vote.user.username | slice: 0 : 1 | titlecase }}-->
                        <!--                            </div>-->
                        <!--                            <mat-menu #menu="matMenu" class="userDisplayMenu">-->
                        <!--                                <app-user-info [user]="vote.user"></app-user-info>-->
                        <!--                            </mat-menu>-->
                        <!--                            <br>-->
                        <!--                            <span class="pl-10">{{ vote.user.username }}</span>-->
                        <!--                        </ng-container>-->
                    </div>
                </div>

                <div *ngIf="!votes.length" class="table-row">
                    <div class="empty-row">No data.</div>
                </div>
            </div>
        </div>
    </div>
</div>

